import React from 'react';
import EventsTable from '../../../components/MatchTimelineTable/EventsTable';

const HalfGoalsTable = (props) => {
  const eventTime = props.isFirstHalfGoals
    ? props.getLatestEventTime() : props.getSecondPeriodStartTime();

  const halfGoals = props.matchTimeline.filter((event) => (
    event.eventType === props.eventType.GOAL_HOME
    || event.eventType === props.eventType.GOAL_AWAY
    || event.eventType === props.eventType.EARLY_PAYOUT
    || event.eventType === props.eventType.GOLDEN_GOAL
    || event.eventType === props.eventType.CORNER_HOME
    || event.eventType === props.eventType.CORNER_AWAY)
    && (props.isFirstHalfGoals
      ? new Date(event.dateTime).getTime() <= new Date(eventTime).getTime()
      : new Date(event.dateTime).getTime() >= new Date(eventTime).getTime()
    ));

  const allHalfEvents = props.filterGoalsToAccountForGoldenGoal(halfGoals);

  return allHalfEvents?.length > 0
    && (
      <EventsTable
        goals={allHalfEvents}
        getTimezone={props.getTimezone}
        eventType={props.eventType}
        markets={props.markets}
      />
    );
};

export default HalfGoalsTable;
